/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.236
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listBusiTrackInfo,
	listBusiTrackInfoInit,
	listBusiTrackInfoByAuthorizations,
	deleteBusiTrackInfo
} from '@api/lcf/BusiTrackInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listBusiTrackInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBusiTrackInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listBusiTrackInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBusiTrackInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listBusiTrackInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBusiTrackInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteBusiTrackInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteBusiTrackInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
